<template>
  <CModal alignment="center" :visible="show" @close="$emit('close')">
    <CModalHeader class="bg-primary">
      <CModalTitle class="text-light fs-6">選擇日期及時間</CModalTitle>
    </CModalHeader>
    <CModalBody>
      <p>請選擇時間範圍選擇器</p>

      <input
        class="ms-3 me-2"
        type="radio"
        name="dateRange"
        value="1"
        v-model="picked"
      />
      <span>日期選擇器</span>
      <input
        class="ms-3 me-2"
        type="radio"
        name="dateRange"
        value="2"
        v-model="picked"
      />
      <span>日期及時間選擇器</span>
      <input
        class="ms-3 me-2"
        type="radio"
        name="dateRange"
        value="3"
        v-model="picked"
      />
      <span>日期範圍選擇器</span>
      <input
        class="ms-3 me-2"
        value="4"
        type="radio"
        name="dateRange"
        v-model="picked"
      />
      <span>日期及時間範圍選擇器</span>
      <DatePicker class="mt-3" v-if="picked === '1'" v-model="test">
        <template v-slot="{ inputValue, inputEvents }">
          <div class="d-flex align-items-center col-6 position-relative">
            <CFormInput :value="inputValue" v-on="inputEvents" readonly />
            <img
              class="calendar-img position-absolute"
              src="@/assets/icons/calendar.svg"
            />
          </div>
        </template>
      </DatePicker>

      <DatePicker
        class="mt-3"
        v-if="picked === '2'"
        v-model="test"
        is24hr
        mode="dateTime"
      >
        <template v-slot="{ inputValue, inputEvents }">
          <div class="d-flex align-items-center col-6 position-relative">
            <CFormInput :value="inputValue" v-on="inputEvents" readonly />
            <img
              class="calendar-img position-absolute"
              src="@/assets/icons/calendar.svg"
            />
          </div>
        </template>
      </DatePicker>

      <DatePicker class="mt-3" v-if="picked === '3'" v-model="test" is-range>
        <template v-slot="{ inputValue, inputEvents }">
          <div class="d-flex align-items-center">
            <div class="position-relative d-flex align-items-center">
              <CFormInput
                :value="inputValue.start"
                v-on="inputEvents.start"
                readonly
              />
              <img
                class="calendar-img position-absolute"
                src="@/assets/icons/calendar.svg"
              />
            </div>
            ～
            <div class="position-relative d-flex align-items-center">
              <CFormInput
                :value="inputValue.end"
                v-on="inputEvents.end"
                readonly
              />
              <img
                class="calendar-img position-absolute"
                src="@/assets/icons/calendar.svg"
              />
            </div>
          </div>
        </template>
      </DatePicker>

      <DatePicker
        class="mt-3"
        v-if="picked === '4'"
        v-model="test"
        mode="dateTime"
        is24hr
        is-range
      >
        <template v-slot="{ inputValue, inputEvents }">
          <div class="d-flex align-items-center">
            <div class="position-relative d-flex align-items-center">
              <CFormInput
                :value="inputValue.start"
                v-on="inputEvents.start"
                readonly
              />
              <img
                class="calendar-img position-absolute"
                src="@/assets/icons/calendar.svg"
              />
            </div>
            ～
            <div class="position-relative d-flex align-items-center">
              <CFormInput
                :value="inputValue.end"
                v-on="inputEvents.end"
                readonly
              />
              <img
                class="calendar-img position-absolute"
                src="@/assets/icons/calendar.svg"
              />
            </div>
          </div>
        </template>
      </DatePicker>
    </CModalBody>
    <CModalFooter>
      <CButton color="primary" @click="submit">完成</CButton>
      <CButton color="light" @click="$emit('close')"> 取消 </CButton>
    </CModalFooter>
  </CModal>
</template>
<script>
import { DatePicker } from 'v-calendar'
import { ref } from '@vue/reactivity'

export default {
  props: {
    show: {
      type: Boolean,
      default: false,
    },
  },
  emits: ['close', 'picked'],
  components: {
    DatePicker,
  },
  setup(props, { emit }) {
    const picked = ref('1')
    const test = ref('')
    const submit = async () => {
      await emit('picked', picked.value)
      emit('close')
    }
    return {
      picked,
      test,
      submit,
    }
  },
}
</script>
<style lang="scss" scoped>
img {
  width: 15px;
  margin: 0 10px;
}
.content {
  background-color: #fff;
  border: 1px solid #bdbdbd;
  outline: none;
}
.remark-btn {
  font-size: 14px;
  color: #fff;
}
.options-box {
  height: 500px;
  overflow: scroll;
}
.calendar-img {
  width: 20px;
  right: 5px;
}
</style>
